export const TIMED_PROMPT_INTERVAL_MS = 14 * 24 * 60 * 60 * 1000;
export const PWA_INSTALL_PROMPT_KEY = 'pwa-install-dismissed-at';
export const WEB_PUSH_PROMPT_KEY = 'web-push-prompted-at';

export function shouldOfferTimedPrompt(
  storedAt: string | null,
  now: number,
  intervalMs = TIMED_PROMPT_INTERVAL_MS
): boolean {
  if (!storedAt) return true;
  const at = Number(storedAt);
  if (!Number.isFinite(at)) return true;
  return now - at >= intervalMs;
}

export function shouldOfferTimedPromptFromStorage(
  key: string,
  now = Date.now()
): boolean {
  if (typeof window === 'undefined') return false;
  return shouldOfferTimedPrompt(localStorage.getItem(key), now);
}

export function markTimedPrompt(key: string, now = Date.now()): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(key, String(now));
}
